import { render } from "./KangeHongLogin.vue?vue&type=template&id=137969b5&ts=true"
import script from "./KangeHongLogin.vue?vue&type=script&lang=ts"
export * from "./KangeHongLogin.vue?vue&type=script&lang=ts"

import "./KangeHongLogin.vue?vue&type=style&index=0&id=137969b5&lang=less"

import exportComponent from "/builds/fe/keyan-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__